<template>
  <div class="maincen">
    <div class="catalog">
      <div class="line"></div>
      <div class="catalogTit">收藏中心</div>
    </div>
    <el-row :gutter="80">
      <el-col :span="6" v-for="item in collectionList" :key="item.fid">
        <div class="grid-content bg-purple" @click="showDetail(item.fid)">
          <div class="imgBox">
            <img :src="item.coverlogo" alt />
          </div>

          <div class="metTit">{{item.teamatName}}</div>
          <div class="metuser">作者：{{item.author}}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {api} from '../../assets/api/axios.js';
export default {
  data() {
    return {
      activeName: 'first',
      par:{
        pageNum:1,
        pageSize:8
      },
      collectionList:[],
      total:0
    }
  },
  created(){
    this.loadCollectionList();
  },
  methods: {
    async loadCollectionList(){
      var res = await api.post('/front/personal/myCollection',this.par)
      this.collectionList = res.data?res.data:[];
    },
    showDetail(fid){
      this.$router.push({
        path: '/teachingmat/Matdetails',
        query: {
          fid: fid
        }
      })
    },
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>
<style lang="scss" scoped>
.maincen {
  margin: 0 30px;
  min-height: 712px;
}
.catalog {
  overflow: hidden;
  padding: 20px 0 10px;
  border-bottom: 1px solid #e6e6e6;
  .line {
    width: 4px;
    height: 20px;
    background: rgba(181, 14, 5, 1);
    float: left;
    margin-right: 8px;
  }
  .catalogTit {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
}
.metTit {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  margin: 10px 0;
}
.metuser {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
}
.imgBox {
  width: 100%;
  height: 181px;
  margin-top: 20px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
